import React, { ReactElement } from 'react';
import classnames from 'classnames';

export type IconNames =
  | '4-way-move-16'
  | '4-way-move-24'
  | '4-way-move-48'
  | '4-way-nav'
  | 'ac-power'
  | 'accesspoint'
  | 'accesspoint-outline'
  | 'account'
  | 'acessibility'
  | 'aci'
  | 'active-speaker'
  | 'active-speaker-cross'
  | 'activities'
  | 'add'
  | 'add-contact'
  | 'add-contain'
  | 'add-outline'
  | 'admin'
  | 'alarm'
  | 'alert'
  | 'alert-blank'
  | 'alerting'
  | 'all-calls'
  | 'analysis'
  | 'android-home'
  | 'animation'
  | 'annotation'
  | 'answer-oldest'
  | 'applause'
  | 'application'
  | 'applications'
  | 'apps'
  | 'arrow'
  | 'arrow-down-tail'
  | 'arrow-left-tail'
  | 'arrow-right-tail'
  | 'arrow-up-tail'
  | 'asterisk'
  | 'at'
  | 'at-contain'
  | 'attachment'
  | 'audio-broadcast'
  | 'audio-min'
  | 'audio-plus'
  | 'audio-settings'
  | 'aux-camera'
  | 'back'
  | 'backup-data'
  | 'battery'
  | 'battery-0'
  | 'battery-25'
  | 'battery-50'
  | 'battery-75'
  | 'battery-full'
  | 'bdb'
  | 'bell'
  | 'bell-cross'
  | 'blocked'
  | 'bluetooth'
  | 'bluetooth-contain-cross'
  | 'bluetooth-contained'
  | 'bluetooth-outline'
  | 'bookmark'
  | 'briefcase'
  | 'brightness'
  | 'broadcast-message'
  | 'broken-image'
  | 'browser'
  | 'bug'
  | 'calendar'
  | 'calendar-meetings'
  | 'calendar-weekly'
  | 'call-forward-divert'
  | 'call-handling'
  | 'call-log'
  | 'call-rate'
  | 'callback'
  | 'camera'
  | 'cart'
  | 'certified'
  | 'chapters'
  | 'charging'
  | 'chats'
  | 'check'
  | 'check-outline'
  | 'check-square'
  | 'check-square-o'
  | 'checklist'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-left-double'
  | 'chevron-right'
  | 'chevron-right-circle'
  | 'chevron-right-double'
  | 'chevron-up'
  | 'circle'
  | 'cisco'
  | 'clipboard'
  | 'clipboard-md'
  | 'clipboard-sm'
  | 'clock'
  | 'clone'
  | 'close'
  | 'close-keyboard'
  | 'cloud'
  | 'cloud-config-16'
  | 'cloud-config-24'
  | 'cloud-config-48'
  | 'cloud-upload'
  | 'cog'
  | 'comment'
  | 'communities'
  | 'community'
  | 'compass'
  | 'compliance'
  | 'computer'
  | 'computer-queue'
  | 'conference'
  | 'configurations'
  | 'contact'
  | 'contact-card'
  | 'contract-login'
  | 'contract-login-md'
  | 'contract-login-sm'
  | 'cpu-chip'
  | 'create-page'
  | 'data-usage'
  | 'day'
  | 'dc-power'
  | 'default-app'
  | 'delete'
  | 'desk-phone'
  | 'device-crash'
  | 'device-faults'
  | 'device-reload'
  | 'devices'
  | 'diagnostics'
  | 'dial'
  | 'directory'
  | 'disc'
  | 'disc-not-connected'
  | 'display'
  | 'dms'
  | 'dna'
  | 'document'
  | 'document-camera'
  | 'document-camera-cross'
  | 'download'
  | 'download-contain'
  | 'draggable'
  | 'draw'
  | 'dropdown'
  | 'dual-line'
  | 'edit'
  | 'edit-call'
  | 'email'
  | 'emoticons'
  | 'endpoint'
  | 'eraser'
  | 'error'
  | 'error-outline'
  | 'ethernet'
  | 'exclamation-circle'
  | 'exclamation-triangle'
  | 'exernal-calendar'
  | 'exit'
  | 'exit-contain'
  | 'exit-fullscreen'
  | 'exit-outline'
  | 'export'
  | 'export-16'
  | 'export-24'
  | 'export-48'
  | 'extension-mobility'
  | 'eye'
  | 'eye-closed'
  | 'fbw'
  | 'features'
  | 'feedback'
  | 'feedback-clear'
  | 'feedback-result'
  | 'ffw'
  | 'file'
  | 'file-archive-o'
  | 'file-audio-o'
  | 'file-code-o'
  | 'file-excel-o'
  | 'file-image-o'
  | 'file-o'
  | 'file-pdf-o'
  | 'file-powerpoint-o'
  | 'file-text'
  | 'file-text-o'
  | 'file-video-o'
  | 'file-word-o'
  | 'filter'
  | 'flagged'
  | 'folder'
  | 'forced-sign-in'
  | 'forward-to-mobility'
  | 'fullscreen'
  | 'general-source'
  | 'general-source-cross'
  | 'google-analytics'
  | 'gpu-graphicscard'
  | 'graph'
  | 'grid-view'
  | 'ground'
  | 'group-call'
  | 'group-chat'
  | 'headset'
  | 'headset-cross'
  | 'help'
  | 'help-alt'
  | 'help-outline'
  | 'hfc-node-16'
  | 'hfc-node-24'
  | 'hfc-node-48'
  | 'hide-editor'
  | 'highlight'
  | 'highlight-line'
  | 'highlighter'
  | 'highlighter-check'
  | 'history'
  | 'home'
  | 'hue'
  | 'hunt-group'
  | 'idefix'
  | 'image'
  | 'image-contain'
  | 'import'
  | 'import-16'
  | 'import-24'
  | 'import-48'
  | 'inbox'
  | 'incoming-call'
  | 'info'
  | 'info-circle'
  | 'info-outline'
  | 'insights'
  | 'instant-meeting'
  | 'intercom'
  | 'intercom-duplex-connected'
  | 'intercom-whisper'
  | 'invite'
  | 'jump-out'
  | 'key-expansion-module'
  | 'keyboard'
  | 'keyboard-close'
  | 'keywords'
  | 'language'
  | 'laser-pointer'
  | 'layers'
  | 'layout'
  | 'learning'
  | 'leave-meeting'
  | 'left-arrow'
  | 'lifecycle'
  | 'lightbulb'
  | 'like'
  | 'line-out-left'
  | 'line-out-right'
  | 'link'
  | 'link-broken'
  | 'list-menu'
  | 'list-view'
  | 'location'
  | 'lock'
  | 'lock-contain'
  | 'locked-speaker'
  | 'mail'
  | 'mail-read'
  | 'manage-cable'
  | 'maximize'
  | 'media-viewer'
  | 'meet-me'
  | 'meeting-room'
  | 'memory-ram'
  | 'merge-call'
  | 'message'
  | 'mic-in'
  | 'micro-blog'
  | 'microphone'
  | 'minimize'
  | 'missed-call'
  | 'mlpp-1'
  | 'mlpp-2'
  | 'mlpp-3'
  | 'mlpp-4'
  | 'mlpp-5'
  | 'mobile-phone'
  | 'mobile-presenter'
  | 'month'
  | 'more'
  | 'move-page'
  | 'multi-display'
  | 'music'
  | 'mute'
  | 'network'
  | 'new-call'
  | 'no-signal'
  | 'notebook-in'
  | 'notes'
  | 'numbered-input'
  | 'numbered-output'
  | 'off-hook'
  | 'other-phone'
  | 'outbox'
  | 'outgoing-call'
  | 'paired-audio'
  | 'paired-call'
  | 'panel-shift-left'
  | 'panel-shift-right'
  | 'parked'
  | 'participant-list'
  | 'pass-mouse'
  | 'pause'
  | 'pc'
  | 'pencil'
  | 'persistent-chat'
  | 'phone'
  | 'phone-cross'
  | 'picture-in-picture'
  | 'pin'
  | 'pip'
  | 'pip-0'
  | 'pip-1'
  | 'pip-2'
  | 'pip-3'
  | 'play'
  | 'play-contained'
  | 'playlist'
  | 'plugin'
  | 'plus'
  | 'point'
  | 'poll'
  | 'popout'
  | 'popup-dialogue'
  | 'power'
  | 'power-contain'
  | 'presence-available'
  | 'presence-end'
  | 'presence-offline'
  | 'presentation'
  | 'prevent-download'
  | 'prevent-download-contain'
  | 'print'
  | 'priority'
  | 'privacy'
  | 'private'
  | 'profile-settings'
  | 'proximity'
  | 'proximity-not-connected'
  | 'quality'
  | 'question-circle'
  | 'raise-hand'
  | 'read-email'
  | 'recent-apps'
  | 'record'
  | 'redial'
  | 'refresh'
  | 'remove'
  | 'remove-contact'
  | 'remove-contain'
  | 'remove-outline'
  | 'reply-all'
  | 'report'
  | 'reset'
  | 'right-arrow'
  | 'right-arrow-closed-contained'
  | 'right-arrow-closed-outline'
  | 'right-arrow-contain'
  | 'right-arrow-contained'
  | 'right-arrow-outline'
  | 'ringer-settings'
  | 'rotate-object-ccw'
  | 'rotate-object-cw'
  | 'router'
  | 'router-outline'
  | 'rtprx'
  | 'rtprx-rtptx-duplex'
  | 'rtptx'
  | 'running-application'
  | 'save'
  | 'schedule-add'
  | 'screen-capture'
  | 'screen-capture-square'
  | 'sd'
  | 'search'
  | 'self-view'
  | 'self-view-alt'
  | 'self-view-crossed'
  | 'send'
  | 'send-email'
  | 'sent'
  | 'setup-assistant'
  | 'share'
  | 'share-contain'
  | 'share-content'
  | 'shipment'
  | 'show-editor'
  | 'sign-in'
  | 'sign-out'
  | 'signal-1'
  | 'signal-2'
  | 'signal-3'
  | 'signal-4'
  | 'skip-bw'
  | 'skip-fw'
  | 'slides'
  | 'social-facebook'
  | 'social-linkedin'
  | 'social-twitter'
  | 'soft-phone'
  | 'software'
  | 'software-certified'
  | 'software-certified-md'
  | 'software-certified-sm'
  | 'software-suggested'
  | 'software-suggested-md'
  | 'software-suggested-sm'
  | 'sort-amount-asc'
  | 'sort-amount-desc'
  | 'sound'
  | 'space'
  | 'spam'
  | 'spark'
  | 'speaker'
  | 'speaker-cross'
  | 'speaker-out-left'
  | 'speed-dial'
  | 'spinner'
  | 'square-o'
  | 'square-o-checked'
  | 'stability'
  | 'star'
  | 'star-empty'
  | 'star-half'
  | 'step-backward'
  | 'step-forward'
  | 'step-next'
  | 'step-prev'
  | 'stop'
  | 'storage'
  | 'subscribe'
  | 'swap-calls'
  | 'swap-camera'
  | 'swap-video-camera'
  | 'switch'
  | 'switch-outline'
  | 'syslog'
  | 'tables'
  | 'tablet'
  | 'tags'
  | 'team-collapsed-view'
  | 'team-expanded-view'
  | 'terminalalt'
  | 'text'
  | 'text-color'
  | 'text-format'
  | 'text-size'
  | 'thumbnail-view'
  | 'time'
  | 'timeline'
  | 'tine'
  | 'toggle-menu'
  | 'too-fast'
  | 'too-slow'
  | 'tools'
  | 'touch'
  | 'touch-gesture'
  | 'touch-point'
  | 'transcript'
  | 'transfer'
  | 'transfer-to-mobile'
  | 'transit'
  | 'trash'
  | 'tree-closed'
  | 'tree-opened'
  | 'uikit'
  | 'universal-inbox'
  | 'unlock'
  | 'upload'
  | 'upload-contain'
  | 'usb'
  | 'user'
  | 'user-queue'
  | 'vibrate'
  | 'video'
  | 'video-cross'
  | 'video-input'
  | 'video-layout'
  | 'video-settings'
  | 'video-tips'
  | 'view-feed-16'
  | 'view-feed-24'
  | 'view-feed-48'
  | 'view-feed-dual'
  | 'view-feed-multi'
  | 'view-feed-single'
  | 'view-preview-telepresence'
  | 'view-side-by-side'
  | 'view-split'
  | 'view-stacked'
  | 'virtual-machine'
  | 'voicemail'
  | 'volume'
  | 'volume-cross'
  | 'waiting-silence'
  | 'wallpaper'
  | 'warning'
  | 'warning-outline'
  | 'watchlist'
  | 'web-camera'
  | 'web-sharing'
  | 'webex'
  | 'webex-meetings-16'
  | 'webex-meetings-24'
  | 'webex-meetings-48'
  | 'webex-teams-16'
  | 'webex-teams-24'
  | 'webex-teams-48'
  | 'webhook'
  | 'whisper'
  | 'whiteboard'
  | 'whiteboard-cross'
  | 'wifi'
  | 'wifi-1'
  | 'wifi-2'
  | 'wifi-3'
  | 'wlc'
  | 'wlc-outline'
  | 'work'
  | 'zip'
  | 'zoom-in'
  | 'zoom-out';

export interface IconProps {
  className?: string;
  name: IconNames;
  testId?: string;
}

export function Icon({
  name,
  className,
  testId = '',
}: IconProps): ReactElement {
  const classes = classnames(className, {
    [`icon-${name}`]: true,
  });

  return (
    <span
      className={classes}
      data-testid={testId}
      role="img"
      aria-label="Icon"
    />
  );
}
